import { render } from "./DefaultLabel.vue?vue&type=template&id=721cb3fa"
import script from "./DefaultLabel.vue?vue&type=script&lang=js"
export * from "./DefaultLabel.vue?vue&type=script&lang=js"
script.render = render

export default script